import React, { useState, useEffect } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { Modal, Button, Input, Checkbox, Select } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import useApi from 'hooks/useApi'

export default NiceModal.create(({ order, job }) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const [languages, setLanguages] = useState([])
  const [inheritPurchaseOrder, setInheritPurchaseOrder] = useState(true)
  const [types, setTypes] = useState([])
  const modal = useModal()

  const [typeOptions] = useApi(`/rest/v2/ordertasktype?pageSize=10000`)
  const [languageOptions] = useApi(`/rest/v2/language`)

  useEffect(() => {
    setTypes(
      typeOptions
        ?.filter(({ shortname }) => ['VO', 'PR'].includes(shortname))
        .map(({ shortname, name }) => ({ value: shortname, label: name })) || []
    )
  }, [typeOptions])

  const onSubmit = (event) => {
    setLoading(true)
    event.preventDefault()

    const data = JSON.stringify({
      language: languages.map(({ innerValue }) => `${innerValue}`),
      tasktypes: types.map(({ value }) => value),
      orderid: order.uid,
      jobid: job.uid,
      inheritCustomerReference: [inheritPurchaseOrder ? 'on' : 'off'],
    })

    const body = new FormData()
    body.append('data', data)

    fetch(`/ordertask/createmultipledefaultversions.json`, { method: 'POST', body })
      .then(() => {
        modal.resolve()
        modal.remove()
        setLoading(false)
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => (loading || !(!!languages?.length)) ? undefined : onSubmit()}
      title={formatMessage(messages.title)}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Select
          required
          label="Languages"
          size="xs"
          value={languages}
          onChange={setLanguages}
          options={languageOptions?.map(({ uid, name }) => ({ value: Math.random(), innerValue: uid, label: name })) }
          isMulti
          hideSelectedOptions={false}
        />

        <Select
          label="Task Types"
          size="xs"
          value={types}
          onChange={setTypes}
          options={typeOptions?.map(({ shortname, name }) => ({ value: shortname, label: name })) }
          isMulti
        />

        <Checkbox
          onChange={() => setInheritPurchaseOrder(!inheritPurchaseOrder)}
          checked={inheritPurchaseOrder}
          label={`Inherit '${order.customerReference}' P.O. from order`}
        />

        <Button
          type="submit"
          size="sm"
          disabled={loading || !(!!languages?.length)}
        >
          { loading ? 'Creating..' : 'Create' }
        </Button>
      </form>
    </Modal>
  )
})
